import React, { useEffect, useState } from 'react';
import { CardElement, useStripe, useElements, PaymentRequestButtonElement } from '@stripe/react-stripe-js';
import { PaymentRequest } from '@stripe/stripe-js'; // 👈 important
import './StripeCheckoutForm.style.css';
interface Props {
  clientSecret: string;
  amount: number; // 👈 pass from Order
  onSuccess: () => void;
}

const StripeCheckoutForm: React.FC<Props> = ({ clientSecret, amount, onSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [paymentRequest, setPaymentRequest] = useState<PaymentRequest | null>(null);

  useEffect(() => {
    if (!stripe) return;

    const pr = stripe.paymentRequest({
      country: 'GB', // set your real country
      currency: 'gbp',
      total: {
        label: 'Order Total',
        amount: Math.round(amount * 100), // Stripe expects cents
      },
      requestPayerName: true,
      requestPayerEmail: true,
    });

    pr.canMakePayment().then(result => {
      console.log('result')
      console.log(result)
      if (result) {
        setPaymentRequest(pr);
      }
    });
  }, [stripe, amount]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!stripe || !elements) return;

    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement)!,
      }
    });

    if (result.error) {
      console.error(result.error.message);
    } else {
      if (result.paymentIntent.status === 'succeeded') {
        onSuccess();
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className="checkoutContainer">
      {paymentRequest && (
        <div className="paymentRequestButton">
          <PaymentRequestButtonElement
            options={{ paymentRequest }}
          />
        </div>
      )}

      <div className="cardElement">
        <CardElement options={{
          style: {
            base: {
              fontSize: '16px',
              color: '#333',
              '::placeholder': { color: '#bbb' },
              fontFamily: 'Inter, Roboto, sans-serif'
            },
            invalid: {
              color: '#e53935',
            }
          }
        }} />
      </div>

      <button
        type="submit"
        disabled={!stripe}
        className="payButton"
      >
        💸 Confirm & Pay
      </button>
    </form>
  );
};

export default StripeCheckoutForm;
